import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { ShadowEvaluationLog } from 'app/shared/eventsOld/models';
import { TRANSACTION_QUERY_KEYS } from 'app/modules/transactions/queries/keys';
import {
  ActionEventExternalId,
  TxnEventExternalId,
  txnEventExternalId,
} from 'app/shared/types/eventExternalIds';
import { useHashedId } from 'app/shared/hooks/useHashedId';

export const useGetShadowEvaluationLog = (
  enabled?: boolean,
  eventExternalId?: TxnEventExternalId | ActionEventExternalId,
  // Txn and action events resolve via different fast tables, so each has its
  // own cached route. Callers pass the event type so we hit the right resolver.
  eventType: 'txn' | 'action' = 'txn',
) => {
  // will always be set when query is issued
  const parsedExternalId = eventExternalId || txnEventExternalId('');
  const { hashedId, useHashed } = useHashedId(parsedExternalId);
  return useQuery({
    queryKey: TRANSACTION_QUERY_KEYS.getTxnShadowEvaluation(
      useHashed ? hashedId : parsedExternalId,
      eventType,
    ),
    queryFn: () =>
      // Cached routes are per-object-type (txn vs action fast tables); the
      // legacy route is shared (/txn-events/<external_id>/shadow_evaluation_log
      // serves both event types).
      useHashed
        ? get<ShadowEvaluationLog>(
            `/v1/${eventType === 'action' ? 'action-events' : 'txn-events'}/cached/${hashedId}/shadow_evaluation_log`,
          )
        : get<ShadowEvaluationLog>(
            `/v1/txn-events/${encodeURIComponent(parsedExternalId)}/shadow_evaluation_log`,
          ),
    enabled: Boolean(enabled && !!eventExternalId),
    initialData: {
      evaluation_id: '',
      event_id: txnEventExternalId(''),
      rule_executions: {},
    },
  });
};
